import { createContext, useContext, useState } from 'react'
import { Period } from './constants'

type AnalyticsContextValue = {
  period: Period
  setPeriod: (period: Period) => void
}

export const AnalyticsContext = createContext<AnalyticsContextValue>({ period: Period.LastWeek, setPeriod: () => {} })

const AnalyticsContextProvider = AnalyticsContext.Provider

export const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const [period, setPeriod] = useState(Period.LastWeek)

  return <AnalyticsContextProvider value={{ period, setPeriod }}>{children}</AnalyticsContextProvider>
}

export const useAnalyticsContext = () => {
  return useContext(AnalyticsContext)
}
